import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AdminService } from "../admin.service";
import { AdminGenerateInvoiceComponent } from '../admin-generate-invoice/admin-generate-invoice.component';

@Component({
  selector: 'app-admin-invoice',
  templateUrl: './admin-invoice.component.html',
  styleUrls: ['./admin-invoice.component.css']
})
export class AdminInvoiceComponent implements OnInit {

  constructor(
    private matDialog: MatDialog,
        private services: AdminService,
  ) {}

  ngOnInit(): void {
  }

  openInvoiceDialog() {
      const dialogRef = this.matDialog.open(AdminGenerateInvoiceComponent, {
        height: "90vh",
        width: '80vw',
        // data: item,
        autoFocus: false,
      });
  
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          console.log('Invoice generated:', result);
          // Call API to save or generate invoice here
        }
      });
    }

}
